import { UserSummary } from './UserSummary';

export interface UpdateUserRequest {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export const updateUserRequestFromUserSummary = (
  userSummary?: UserSummary,
): UpdateUserRequest => ({
  firstName: userSummary?.firstName ?? '',
  lastName: userSummary?.lastName ?? '',
  email: userSummary?.email ?? '',
  phone: userSummary?.phone ?? '',
});

export const updateUserRequestOutputTransformer = (req: UpdateUserRequest) => ({
  first_name: req.firstName,
  last_name: req.lastName,
  email: req.email,
  phone: req.phone,
});
